module.exports = __webpack_public_path__ + "img/PRCA2_DC.a9211fe3.png";